// Styles
import "./styles.scss";

function ButtonPrimary(props) {
  const {buttonText, onClickHandler, disabled, className} = props;
  return (
    <div className="button-primary">
      <button
        disabled={disabled}
        className={`btn btn-primary border-active ${className || ''}`}
        onClick={onClickHandler}
      >
        {buttonText}
        <img src={props.icon} alt="" className="arrow-icon" />
      </button>
    </div>
  );
}

export default ButtonPrimary;
